import { redirect } from '@tanstack/react-router'

import { ensureSessionResolved } from '@/auth/session'
import { useAuthStore } from '@/auth/store'

interface GuardArgs {
  location: { href: string }
}

/** Garde des routes internes : membre ou admin Oyenga. */
export async function requireInternal({ location }: GuardArgs): Promise<void> {
  await ensureSessionResolved()
  const { status, user } = useAuthStore.getState()

  if (status !== 'authenticated' || !user) {
    throw redirect({ to: '/login', search: { redirect: location.href } })
  }
  if (user.kind !== 'internal') {
    throw redirect({ to: '/portal' })
  }
}

/** Garde de l'espace client. */
export async function requirePortal({ location }: GuardArgs): Promise<void> {
  await ensureSessionResolved()
  const { status, user } = useAuthStore.getState()

  if (status !== 'authenticated' || !user) {
    throw redirect({ to: '/login', search: { redirect: location.href } })
  }
  if (user.kind !== 'portal') {
    throw redirect({ to: '/' })
  }
}

/** Garde réservée aux administrateurs (page Équipe). */
export async function requireAdmin(args: GuardArgs): Promise<void> {
  await requireInternal(args)
  const { user } = useAuthStore.getState()
  if (user?.role !== 'admin') {
    throw redirect({ to: '/' })
  }
}

/** Route d'accueil d'un utilisateur selon son type. */
export function homePathFor(kind: 'internal' | 'portal'): '/' | '/portal' {
  return kind === 'portal' ? '/portal' : '/'
}
